import React from 'react';
const Button = props => {
    return (
        <button
            {...props}
            type={props.type}
            className={props.class}
            style={{ ...props.style }}
        >{props.children}
        </button>
    );
};
export default Button;